import { Permission } from '@cims-online/shared'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { DSType, useTypesTableContext } from '../../../../TypesTableContext'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRemoveNotification } from 'hooks/notificationHandler'
import { useSoftRemoveDsTypeMutation } from 'schema'

export function useRemove(): RemoveRowActionOptions<DSType> {
  const { refetch } = useTypesTableContext()
  const [remove] = useSoftRemoveDsTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      softRemoveDSType: {
        type: { name },
      },
    }) => simpleRemoveNotification(name),
  })
  return {
    disabled: ({ submittals }) =>
      !!submittals.length
        ? {
            message:
              'Types cannot be deleted if they are associated with one or more Design Submittals',
          }
        : false,
    permission: Permission.RemoveRestoreDesignSubmittalType,
    onRemove: async ({ id }) => {
      await remove({ variables: { id } })
      refetch()
    },
  }
}
